<template lang="html">
  <div class="box-wrap">
    <div class="name">{{name}}</div>
    <div class="box">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    name: String
  },
  created() {
  },
  data() {
    return {
    }
  },
  methods: {
  }
}

</script>

<style lang="stylus" scoped>
.box-wrap {
  width: 100%;
}

.box {
  width: 100%;

  &:before, &:after {
    display: block;
    content: '';
    width: 100%;
    height: 3px;
    background: url('../../../../../static/img/common/box-border.png');
    background-size: 100% 100%;
  }
}

.name {
  margin-bottom: 13px;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// index.vue?02822c55